import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import { TrimText } from "../components/common/TrimText";
import AuditTrail from "../components/courses/Programs/AuditTrail";
import DetailsOfPrograms from "../components/courses/Programs/DetailsOfPrograms";
import ProgrammeGradeBookTable from "../components/courses/Programs/ProgrammeGradeBookTable";
import { GetProgramsDetailsCancelToken } from "../services/ProgrammeServices";
import { GlobalIconNames } from "../utils/GlobalIconNames";
import { GetStudentDetailsCancelToken } from "../services/StudentsSettingServices";
import {
  lockGradeProgrammeToggle,
} from "../services/GradeSettingService";
import axios from "axios";
import Swal from "sweetalert2";
import ProgrammeGrademixGradeBookTable from "../components/courses/Programs/ProgrammeGrademixGradeBookTable";
import PermissionsGate from "../utils/permissionGate";
const Programs = () => {
  const history = useHistory();
  const location = useLocation();
  let currentTabValue = location?.pathname?.split("/");
  const { tab, type, id, subTab, subtype } = useParams();
  const [programmeData, setProgrammeData] = useState({ course: "" });
  const [studentName, setStudentName] = useState("")
  const [studentData, setStudentData] = useState({})
  const [timeTableDoc, setTimeTableDoc] = useState();
  const [timeTableDocName, setTimeTableDocName] = useState("");
  const [refresh, setRefresh] = useState(false)
  const [enableProgramOverview, setEnableProgramOverview] = useState(0);
  const [enableAutodesk, setEnableAutodesk] = useState(0);
  const [gradeLockLoading, setGradeLockLoading] = useState(false);

  // Redirect if PMC linked and trying to access not allowed tabs
  useEffect(() => {
    if (programmeData) {
      if (Number(programmeData.qualificationsLinkedPmc) === 1) {
        const tempTabNotAllowedList = ["grade", "gradeSetting"];
        if (tab === "programme" && tempTabNotAllowedList.includes(subtype)) {
          history.push(`/courseAdministration/Programmes/programme/open/${id}/details`);
        }
      }
    }
  }, [programmeData])

  const handleLockGrades = () => {
    setGradeLockLoading(true)
    lockGradeProgrammeToggle(id, programmeData?.lock_grades ? 0 : 1)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        });
        setRefresh(!refresh);
        setGradeLockLoading(false)
      })
      .catch((err) => {
        console.error("error :", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.response?.data?.message || "Something went wrong",
        });
        setGradeLockLoading(false)
      });
  }
  useEffect(() => {
    const cancelTokenSources = [];
    
    const getStudenDetails = async () => {
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
  
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
  
      try {
        const res = await GetStudentDetailsCancelToken(subTab, source.token);
        if (res.status === 200) {
          setStudentData(res.data?.data_list)
          setStudentName(res.data?.data_list?.first_name + " " + (res.data?.data_list?.last_name ? res.data?.data_list?.last_name : ""));
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };
    if(subTab) {
      getStudenDetails();
    }

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [subTab, type, id]);

  useEffect(() => {
    const cancelTokenSources = [];
    if (type == "open" || type == "duplicate") {

      const getProgrammeDetails = async () => {

        cancelTokenSources.forEach(source => {
          source.cancel('New request made');
        });

        const source = axios.CancelToken.source();
        cancelTokenSources.push(source);
        try {
          const res = await GetProgramsDetailsCancelToken(id, source.token);
          if (res.status === 200) {
            if (res.data) {
              setProgrammeData(res.data.programs);
              setTimeTableDoc(res.data.programs.timeTable);
              setTimeTableDocName(res.data.programs.timeTable)
              setEnableProgramOverview(res.data.programs.is_show_overview)
              setEnableAutodesk(res.data.programs.autodesk)
            }
          } else {
            Swal.fire({
              icon: "Info",
              title: "Info",
              text: "No record found with this id",
            })
            history.push("/courseAdministration/Programmes/programme/show")
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.error(error);
          }
        }
      };

      getProgrammeDetails();
    } else {
      setProgrammeData({ course: "" });
      setTimeTableDoc();
      setTimeTableDocName("")
    }
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [subTab, type, id, refresh]);

  return (
    <>
      <Header></Header>
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar></SideBar>
        <div className={"sidebar-right " + (currentTabValue[3] === "programme" && (currentTabValue[6] === "grade" || currentTabValue[6] === "gradebook") && currentTabValue[7] === "table" ? "bottom-100" : "")}>
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center ">
                    <div className="name-w-head d-flex align-items-center ">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        {currentTabValue.includes("gradebook") ? "Gradebook: " :
                        type == "show" || tab == "auditTrail"
                          ? "Programmes "
                          : type == "add"
                          ? "Add "
                          : "Programme: "}
                        {!currentTabValue.includes("gradebook") && <span
                          title={
                            type == "open"
                              ? programmeData && programmeData.course
                              : ""
                          }
                        >
                          {type == "show" || tab == "auditTrail"
                            ? ""
                            : type == "add"
                            ? "Programme"
                            : programmeData && TrimText(programmeData.course)}
                        </span>}
                        {currentTabValue.includes("gradebook") && <span title={programmeData && programmeData.course}>{`${programmeData && programmeData.course} - ${studentName}`}</span>}
                      </h4>
                    </div>
                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        <div className="add-new-ticket-bx">
                          <button
                            onClick={() => history.goBack()}
                            title="Back"
                            className="btn btn-white-bordered"
                          >
                            <i className="fal fa-angle-left"></i>Back
                          </button>
                        </div>
                      </div>
                    </div>
                    {(type == "open" && programmeData?.pmc_id > 0) ? (
                      <>
                      <div className="text-md-right action2-blk">
                        <div className="ticket-view-btn d-flex align-items-center">
                          <div className="add-new-ticket-bx">
                            <Link
                              to={`/program-management-center/programmes/programme/open/${programmeData?.pmc_id}`}
                              title="Qualification"
                              className="btn btn-white-bordered"
                            >
                              <i className="fal fa-book"></i> PMC
                            </Link>
                          </div>
                        </div>                        
                      </div>
                      {programmeData?.pmc_version_id > 0 ? (                                                  
                        <div className="ticket-view-btn d-flex align-items-center" style={{paddingLeft: "20px"}}>
                          <div className="add-new-ticket-bx">
                            <Link
                              to={`/program-management-center/programmes/versions/gradebook?versionId=${programmeData?.pmc_version_id}&programmeId=${programmeData?.pmc_id}`}
                              title="Got to PMC gradebook"
                              className="btn btn-white-bordered"
                            ><i className="fal fa-graduation-cap"></i>PMC Gradebook</Link>
                          </div>
                        </div>
                        ) : ""}
                      </>
                    ) : null}
                    {(type == "open" && programmeData?.pmc_id > 0) ? (
                      <PermissionsGate
                        scopes={["capgsedit"]}
                        errorProps={{ disabled: true }}
                      >
                        <div className="text-md-right action2-blk">
                          <div className="ticket-view-btn d-flex align-items-center">
                            <div className="add-new-ticket-bx">
                              <button
                                className="btn btn-primary"
                                onClick={() => handleLockGrades()}
                                title={programmeData?.lock_grades ? "Unlock Grades" : "Lock Grades"}
                                disabled={gradeLockLoading}
                              >
                                {programmeData?.lock_grades ? (
                                  <>
                                    {gradeLockLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-unlock"></i>} Unlock Grades
                                  </>
                                ) : (
                                  <>
                                    {gradeLockLoading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-lock"></i>} Lock Grades
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </PermissionsGate>
                    ) : ""}
                  </div>
                </div>
                <div className="tabs-wrap">
                  {type == "show" && (
                    <ul className="nav nav-pills mb-4" id="tabs" role="tablist">
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(
                            type == "open"
                              ? `/courseAdministration/Programmes/programme/open/${id}/details`
                              : `/courseAdministration/Programmes/programme/show`
                          )
                        }
                      >
                        <a
                          className={`nav-link cursor-pointer ${
                            tab === "programme" ? "active" : ""
                          }`}
                          id="pills-tab1"
                          data-toggle="pill"
                          role="tab"
                          aria-controls="pills-tab11"
                          aria-selected="true"
                        >
                          {GlobalIconNames("qualification").html}
                        </a>
                      </li>
                      <li
                        className="nav-item"
                        onClick={() =>
                          history.push(
                            type == "open"
                              ? `/courseAdministration/Programmes/singleAuditTrail/open/${id}`
                              : `/courseAdministration/Programmes/auditTrail/show`
                          )
                        }
                      >
                        <a
                          className={`nav-link cursor-pointer ${
                            tab === "auditTrail" || tab == "singleAuditTrail"
                              ? "active"
                              : ""
                          }`}
                          id="pills-tab2"
                          data-toggle="pill"
                          role="tab"
                          aria-controls="pills-tab12"
                          aria-selected="true"
                        >
                          {GlobalIconNames("audittrail").html}
                        </a>
                      </li>
                    </ul>
                  )}
                  <div className="tab-content" id="pills-tabContent">
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab11"
                      role="tabpanel"
                      aria-labelledby="pills-tab1"
                    >
                      {((tab === "programme" || tab == "singleAuditTrail") &&
                        !currentTabValue.includes("gradebook")) && (
                          <DetailsOfPrograms
                            programmeDetails={programmeData}
                            programmeName={
                              programmeData && programmeData.course
                            }
                            setProgrammeData={setProgrammeData}
                            timeTableDoc={timeTableDoc}
                            timeTableDocName={timeTableDocName}
                            setTimeTableDoc={setTimeTableDoc}
                            setTimeTableDocName={setTimeTableDocName}
                            studentDetails={studentData}
                            refresh={refresh}
                            setRefresh={setRefresh}
                            enableProgramOverview={enableProgramOverview}
                            setEnableProgramOverview={setEnableProgramOverview}
                            setEnableAutodesk={setEnableAutodesk}
                            enableAutodesk={enableAutodesk}
                          />
                        )}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab12"
                      role="tabpanel"
                      aria-labelledby="pills-tab2"
                    >
                      {tab === "auditTrail" && <AuditTrail />}
                    </div>
                    <div
                      className="tab-pane fade active show"
                      id="pills-tab21"
                      role="tabpanel"
                      aria-labelledby="pills-tab21"
                    >
                      {(currentTabValue.includes("gradebook") && programmeData.grading_standard && programmeData.grading_standard == 2) ? (
                        <ProgrammeGrademixGradeBookTable studentDetails={studentData} programmeDetails={programmeData}/>
                      ) : (currentTabValue.includes("gradebook") && programmeData.grading_standard && programmeData.grading_standard != 2) ? (
                        <ProgrammeGradeBookTable studentDetails={studentData} programmeDetails={programmeData}/>
                      ) : <></>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Programs;
